export default __webpack_public_path__ + "static/media/iconLixeiraVazia.30d49795.svg";